export default defineNuxtRouteMiddleware(() => {
	useLayoutStyle().value = null
})
